import { makeStyles, createStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    dragAndDropZone: {
      width: '350px',
      marginTop: '2px',
      cursor: 'pointer',
      margin: '5px 0px',
    },
    middleText: {
      display: 'flex',
      justifyContent: 'center',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 16,
      lineHeight: '0px',
      color: '#2C2D3E',
      marginTop: '100px',
    },
    file: {
      display: 'flex',
      alignItems: 'center',
      padding: '0px 0px',
      position: 'relative',
      marginBottom: '7px',
      marginTop: '5px',
      cursor: 'default',
    },
    fileEdit: {
      display: 'flex',
      alignItems: 'center',
      padding: '5px 15px',
      border: '1px solid rgba(44, 45, 62, 0.3)',
      borderRadius: '3px',
      backgroundColor: 'rgba(255, 255, 255, 0.3)',
      position: 'relative',
      marginBottom: '5px',
      cursor: 'default',
    },
    fileDetails: {
      marginTop: '-2px',
      marginRight: '4px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    fileName: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '13px',
      width: '350px',
      cursor: 'default',
    },
    fileSize: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '11px',
      color: 'rgba(44, 45, 62, 0.5)',
    },
    jpgFile: {
      position: 'relative',
      width: '28px',
      marginRight: '12px',
      cursor: 'default',
    },
    fileRemove: {
      position: 'absolute',
      right: '8px',
      cursor: 'pointer',
      color: 'rgba(44, 45, 62, 0.8)',
    },
    subHeader: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '13px',
    },
    fileDetailsContainer: {
      display: 'flex',
      flexDirection: 'row',
      width: 'calc(100% - 40px)',
      maxWidth: 'calc(100% - 40px)',
      justifyContent: 'space-between',
      gap: '0px',
    },
    downloadFileButton: {
      color: '#3C419A',
      boxShadow: 'none',
      border: 'solid 1px #3C419A',
      padding: '4px 4px 4px 4px',
      '&:hover': {
        backgroundColor: 'rgba(60, 65, 154, 0.3)',
      },
      minWidth: '30px !important',
      maxWidth: '30px !important',
    },
    downloadFileIcon: {
      color: '#3C419A',
      width: 16,
      height: 16,
      fill: '#3C419A !important',
    },
  }),
);
